// removed by extract-text-webpack-plugin
module.exports = {"outerBar":"tN0B8","innerBar":"_2mn1j","percentage":"_26MGE"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ProportionBar.scss
 ** module id = 108
 ** module chunks = 0
 **/